import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";

export default class Pagination extends Component {
    render() {
        const data = this.props;

        const prevPage = data.currentPage > 1 ? data.currentPage - 1 : 1;
        let backButton = <div>
            <Link to={`${data.url}${prevPage}`}>
                {"<<"}
            </Link>
        </div>;

        const nextPage = data.currentPage >= data.pageCount ? data.pageCount : data.currentPage + 1;
        let nextButton = <div>
            <Link to={`${data.url}${nextPage}`}>
                {">>"}
            </Link>
        </div>;

        return <div>
            {backButton}
            {data.currentPage}
            {nextButton}
        </div>;

    }
}

Pagination.propTypes = {
    currentPage: PropTypes.number,
    pageCount: PropTypes.number,
    totalCount: PropTypes.number,
    perPage: PropTypes.number,
};


// WEBPACK FOOTER //
// ./src/js/common/Pagination.js